import { Skeleton } from '@mantine/core';

/** Skeleton for chart components */
export function ChartLoader() {
  return (
    <div className="h-full w-full px-3 pb-3">
      <Skeleton h="100%" w="100%" radius="0.5rem" />
    </div>
  );
}
